import React, {useEffect, useState} from "react";
import {auth, firebase, firestore} from "../firebase/clientApp";
import VoteContent from "../components/VoteContent";
import {useParams} from "react-router-dom";
import {Box, Container} from "@mui/material";
import {useDocument} from "react-firebase-hooks/firestore";
import axios from "axios";
import {API_URL} from "../config";

export default function Vote() {
    const {eventOwnerId, id} = useParams()
    const [user, setUser] = useState(null);
    const [event, eventLoading, eventError] = useDocument(firestore.doc(`users/${eventOwnerId}/events/${id}`))
    const [userData, setUserData] = useState({displayName: '', teamName: ''})

    const [loading, setLoading] = useState(true);

    const backgroundMap = {
        'JZUBjoyQptsQxLe3Ew9g': 'bkg-napoli.png',
        '3e4Qpd8Ez8sKuw3KhbAh': 'bkg-bologna.png',
        'dWX6aZT1r361w4je6UiD': 'bkg-torino.png',
    };

    const backgroundImage = backgroundMap[id] || 'bkg-default.jpg';

    async function loginUser() {
        await auth.signInAnonymously().then(() => {}).catch(alert);
    }

    useEffect(async () => {
        setLoading(true)
        await loginUser()
        firebase.auth().onAuthStateChanged(async (user) => {
            setUser(user);
            await axios.post(`${API_URL}users/${eventOwnerId}/events/${id}/users`,{user: user.uid})
                .then(res =>
                    setUserData({displayName: res.data.displayName ?? '', teamName: res.data.teamName ?? ''})
                )
                .catch()
        })
        setLoading(false)
    }, [])

    if (loading) return <></>

    return (
        <Box sx={{
            backgroundImage:`url(/images/${backgroundImage})`,
            backgroundSize:'cover',
            backgroundPosition:'center',
            minHeight:'100vh',
        }}>
            {(event && !eventLoading && !eventError) &&
                <Container maxWidth={'sm'} className={'vote'} style={{maxHeight: '100%'}}>
                    <VoteContent user={user} event={event} loading={loading} userData={userData} setUserData={setUserData}/>
                </Container>
            }
        </Box>
    )
}
